/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Rte_StrikeInputs */



/**
* | output |
* | --- |
* | "Strikethrough" |
*
* @param {Rte_StrikeInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const rte_strike = /** @type {((inputs?: Rte_StrikeInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Rte_StrikeInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Doorhalen")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Barré")
	return /** @type {LocalizedString} */ ("Strikethrough")
});